module.exports = __webpack_public_path__ + "img/road-vehicle.0d146c2.png";